import type { ReactNode, RefObject } from 'react'

import { PopoverContent } from '@/components/ui/popover'

import type { Notification, NotificationClickHandler } from './notification.interface'
import { NotificationEmpty } from './notification-empty.atom'
import { NotificationHeader } from './notification-header.atom'
import { NotificationList } from './notification-list.atom'

export interface NotificationPopoverContentProps {
  notificationList: Notification[]
  hasUnread: boolean
  onMarkAllRead?: () => void
  onNotificationClick: NotificationClickHandler
  onKeyDown: (event: React.KeyboardEvent) => void
  itemRefs: RefObject<(HTMLDivElement | null)[]>
}

export const NotificationPopoverContent = ({
  notificationList,
  hasUnread,
  onMarkAllRead,
  onNotificationClick,
  onKeyDown,
  itemRefs,
}: NotificationPopoverContentProps): ReactNode => {
  return (
    <PopoverContent
      align="end"
      className="notification-popover w-96 max-w-[calc(100vw-2rem)] p-0 overflow-hidden"
      onKeyDown={onKeyDown}
    >
      <NotificationHeader hasUnread={hasUnread} onMarkAllRead={onMarkAllRead} />
      {notificationList.length === 0 ? (
        <NotificationEmpty />
      ) : (
        <NotificationList
          notificationList={notificationList}
          onNotificationClick={onNotificationClick}
          itemRefs={itemRefs}
        />
      )}
    </PopoverContent>
  )
}

NotificationPopoverContent.displayName = 'NotificationPopoverContent'
